import { RootState } from "../index";

export const getSlice = (state: RootState) => state.customers;
